import { FC, ForwardedRef } from 'react';
import { styled } from 'styled-components';
import SwiperComp from '../SwiperComp';
import { SwiperSlide } from 'swiper/react';
import useMessageStore, { EContentType, IMessage } from '@/store/messageStore';
import Image from '@cps/MediaComp/Image';
import VideoPlayer from './VideoPlayer';
import { forwardRef } from 'react';
import { Message } from '@arco-design/web-react';
import Download from './Download';
import useAppStore from '@/store/appStore';

const PreviewContentWrap = styled.div``;

interface IPreviewContentWrap {
  mediaList: IMessage[];
  showTool: boolean;
}

const PreviewContent = forwardRef((props: IPreviewContentWrap, ref: ForwardedRef<any>) => {
  const swiperRef = useRef<any>();
  const videoPlayerRefs = useRef<any[]>([]);
  const messageStore = useMessageStore();
  const appStore = useAppStore();

  useImperativeHandle<any, any>(ref, () => ({
    swiperRef: swiperRef.current,
  }));

  const getMsgBodyMedia = (msgBody: string) => {
    let result;
    try {
      result = JSON.parse(msgBody);
      // TODO
      result.thumbnail = result.resource;
    } catch (error) {}

    return result;
  };

  return (
    <SwiperComp
      ref={swiperRef}
      style={{ height: '100%', maxWidth: '900rem' }}
      onChange={(inx) => {
        videoPlayerRefs.current[inx]?.resetVideo?.();
      }}
    >
      {props.mediaList?.map((item, inx) => {
        return (
          <SwiperSlide key={item.uniqueId}>
            {Array.isArray(getMsgBodyMedia(item.msgBody)) ? (
              <div>
                {getMsgBodyMedia(item.msgBody).map((item: any, inx: number) => {
                  return (
                    <div className="h-full flex-center">
                      {item.msgType === EContentType.image ? (
                        <div key={inx}>
                          <div className="h-full flex-center">
                            <Image src={getMsgBodyMedia(item.msgBody)} className="w-full" />
                          </div>

                          {props.showTool && <PreviewTool downloadLink={item.msgBody} />}
                        </div>
                      ) : (
                        <div key={inx}>
                          <VideoPlayer
                            src={item.msgBody}
                            ref={(el) => (videoPlayerRefs.current[inx] = el)}
                          />

                          {props.showTool && <PreviewTool downloadLink={item.msgBody} />}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : item.msgType === EContentType.image ? (
              <>
                <div className="h-full flex-center overflow-auto">
                  <Image src={getMsgBodyMedia(item.msgBody)} className="w-full" />
                </div>

                {props.showTool && <PreviewTool downloadLink={item.msgBody} />}

                {appStore.curDevice !== 'phone' && (
                  <div className="absolute left-48 bottom-48">
                    <Download msgBody={item.msgBody} />
                  </div>
                )}
              </>
            ) : (
              <>
                <VideoPlayer src={item.msgBody} ref={(el) => (videoPlayerRefs.current[inx] = el)} />
                {props.showTool && <PreviewTool downloadLink={item.msgBody} />}

                {appStore.curDevice !== 'phone' && (
                  <div className="absolute left-48 bottom-48 z-9">
                    <Download msgBody={item.msgBody} />
                  </div>
                )}
              </>
            )}
            {/* <img className="img-content" src={item.img} alt="" /> */}
          </SwiperSlide>
        );
      })}
    </SwiperComp>
  );
});

const PreviewTool: FC<{ downloadLink: string }> = (props) => {
  const messageStore = useMessageStore();

  return (
    <>
      <Download msgBody={props.downloadLink} className="icon-download" />

      <img
        onClick={() => messageStore.setShowPreviewMedia(false)}
        src={require('@img/chat/icon-close-media.svg')}
        alt=""
        className="icon-close-media"
      />
    </>
  );
};

export default PreviewContent;
